import { AxiosResponse } from "axios";
import { axiosPatch } from "../../axios/axios-config";
import { CommonResponse } from "types/types";

export const UpdateNameRequest = async (
  data: { first_name: string; last_name: string },
  email: string,
  setErrors: Function,
  setSubmitting: Function,
): Promise<void | AxiosResponse<CommonResponse>> => {
  return await axiosPatch(
    `/auth/register/${email}/`,
    data,
    {},
    setErrors,
    setSubmitting,
  );
};
